/* eslint-disable object-curly-newline, max-len */
import React, { useState } from 'react';
import { Popover } from '@mui/material';
import { useHistory } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Bell } from 'lucide-react';
import NotificationsPanel from './NotificationsPanel';
import useNotifications, { routeFor } from './useNotifications';
import './notifications.css';

export default function NotificationBell() {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    items, loading, unreadCount, busyIds, approve, reject, markAllRead, markRead, refetch,
  } = useNotifications();

  const open = Boolean(anchorEl);
  const openMenu = (e) => { setAnchorEl(e.currentTarget); refetch(); };
  const close = () => setAnchorEl(null);

  const openItem = (item) => {
    markRead(item);
    close();
    history.push(routeFor(item));
  };

  return (
    <>
      <button
        type="button"
        className={`shoot-notif-btn${open ? ' is-open' : ''}`}
        onClick={openMenu}
        aria-label={`Notifications${unreadCount ? `, ${unreadCount} unread` : ''}`}
      >
        <span className="shoot-notif-bellwrap">
          <Bell size={20} strokeWidth={1.9} />
          {unreadCount ? (
            <span className="shoot-notif-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
          ) : null}
        </span>
      </button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: '12px',
            border: '1px solid var(--dark-6)',
            boxShadow: '0 14px 44px -14px rgba(9,30,66,0.30)',
            overflow: 'hidden',
          },
        }}
      >
        <NotificationsPanel
          items={items}
          loading={loading}
          unreadCount={unreadCount}
          busyIds={busyIds}
          onMarkAllRead={markAllRead}
          onApprove={approve}
          onReject={reject}
          onOpen={openItem}
          onViewAll={() => { close(); history.push('/notifications'); }}
        />
      </Popover>
    </>
  );
}
